<template>
<main class="row onboarding-wrapper">
    <div class="col-md-12 ob-rightcol">
        <template v-if="existingUser">
            <ExistingUser :userName="agentFullName"></ExistingUser>
        </template>

        <template v-else-if="currentView == 'AGENT_NRDS'">
            <div class="primary-heading" >
                First, enter your NRDS number
            </div>
            <div class="secondary-heading mt-1">
                You know that number you thought you’d never be able to memorize...
            </div>
            <div class="state-agent">
                <div class="sa-frm-row mt-4 mb-1" >
                    <div class="sa-form-control">
                        <input class="sa-control" type="text" name="user_nrds" autocomplete="new-password" placeholder="9 digit NRDS number" @keyup="resetError" v-model = "agentKey"/>
                    </div>
                    <div v-if="errorText == 'enterKey'" class="sa-label error-text" style="text-align:left;">Please enter NRDS number</div>
                    <div v-if="errorText == 'wrongFormat'" class="sa-label error-text" style="text-align:left;">NRDS should be a 9 digit number.</div>
                    <div v-if="errorText == 'wrongInfo'" class="sa-label error-text" style="text-align:left;"> Sorry, we could not found any information for this NRDS number. Please enter a valid one.</div>
                </div>
                <div class="sa-frm-row mb-0">
                    <div class="ob-btn-wrapper" style="border-top:none;float:right;">
                        <button  v-if="!loadingAgentData" class="ob-button" style = "align-items:center" @click = "getAgentDetails">Get Started</button>
                        <div  v-if="loadingAgentData" class="rotate-btn-wrap" style = "align-items:center">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
                <div class="sa-frm-row mt-3">
                    <div class="sa-form-control" style="float:left;width:100%;">
                        <input type="checkbox" id="privacyTerms" v-model="termsOfService" @click="resetError" class="sa-checkbox" name="privacyPolicy" />
                        <div class="sa-label agree-txt-label">
                            <span class="lbl">I accept the <a id="termsOfService" class="cursor-pointer" @click=" showTermsPopup  = true" style="color: rgb(25, 156, 198);text-decoration: underline;">Terms of Service</a>
                            and <a id="privacyPolicy" class="cursor-pointer" @click=" showPrivacyPopup = true" style="color: rgb(25, 156, 198);text-decoration: underline;">Privacy Policy</a>.</span>
                        </div>
                    </div>
                    <div v-if="errorText == 'checkTerms'" class="sa-label error-text" style="text-align:left;">Before using {{orgTitle}}, you must read and agree to our terms of service and privacy policy.</div>
                </div>
            </div>
            <div class="mt-4 region-info-text" >
                {{orgTitle}} is currently available in MN, IA, WI, SD & ND
                request your market here.
            </div>
        </template>
        <template v-else-if="currentView == 'SEND_CODE' ">
            <div class="primary-heading" >
                Phone Authentication
            </div>
            <div class="secondary-heading mt-1">
              We need to verify your mobile number. Please select a number where we can send a text message. 
            </div>
            <div class="state-agent">
                <div class="sa-frm-row mb-1 phone-list-wrap"  style="width: 350px;margin: 0 auto;height: auto;">
                    <template v-for="phoneRow in phoneList">
                        <div :key="phoneRow.number" class="sa-form-control phone-item" >
                            <input type="radio" :value="phoneRow" v-model="phone" class="sa-radio" name="phone" @input="errorText = ''" />
                            <span :class="phoneRow.type == 'test' ? 'test' : '' ">{{`(***)****-${phoneRow.number.slice('-4')}`}}</span>
                        </div>
                    </template>
                </div>
                <div v-if="errorText == 'sendLimitExceeded'" class="sa-label error-text mt-2" style="text-align:left;font-size: 14px;">Max send attempts reached, Please try to complete the verification process or wait for 10 min for code to expire.</div>
                <div v-if="errorText == 'sendingFailed'" class="sa-label error-text mt-2" style="text-align:left;font-size: 14px;">Could not send verification code. Please try again.</div>
                <div v-if="errorText == 'wrongNumber'" class="sa-label error-text mt-2" style="text-align:left;font-size: 14px;">Only test numbers are allowed in qa mode. Test numbers are the ones in green</div>
                <div v-if="errorText == 'enterNumber'" class="sa-label error-text mt-2" style="text-align:left;font-size: 14px;">Please select a phone number to proceed. </div>
                <div class="sa-frm-row mb-0">
                    <div class="ob-btn-wrapper" style="border-top:none;float:right;">
                        <button v-if="!loadingAgentData" class="ob-button mt-2" style="cursor:pointer;align-items:center" @click="sendCode">Proceed</button>
                        <div  v-if="loadingAgentData" class="rotate-btn-wrap mt-2" style = "align-items:center">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="currentView == 'VERIFY_CODE' ">
            <div class="primary-heading" >
                Phone Authentication
            </div>
            <div class="secondary-heading mt-1">
              Please enter the code we have just sent to phone number {{`(***)****-${phone.number.slice('-4')}`}}. 
            </div>
            <div class="state-agent">
                <div class="sa-frm-row mb-1 phone-list-wrap mt-3"  style="width: 350px;margin: 0 auto;height: auto;">
                    <div class="sa-form-control">
                        <input class="sa-control" type="number" placeholder="Verification Code" @keyup="resetAndVerify" v-model = "verificationCode"/>
                    </div>
                    <div style="float:right;">
                         <span class="lbl">Code will expire in {{textContent}}</span>
                    </div>
                    <!-- height fix for if the above div is hidden-->
                    <!-- <div v-else style="height: 21px;"></div> -->
                    <div v-if="errorText == 'enterCode'" class="sa-label error-text" style="text-align:left;">Please enter the verification code sent to your phone</div>
                    <div v-if="errorText == 'wrongCode'" class="sa-label error-text" style="text-align:left;">Invalid Code.</div>
                    <div v-if="errorText == 'sendLimitExceeded'" class="sa-label error-text mt-2" style="text-align:left;font-size: 14px;">Max send attempts reached, Please try to complete the verification process or wait for 10 min for code to expire.</div>
                    <div v-if="errorText == 'sendingFailed'" class="sa-label error-text mt-2" style="text-align:left;font-size: 14px;">Could not send verification code. Please try again.</div>
                 </div>
                <div class="sa-frm-row mb-0">
                    <div class="ob-btn-wrapper" style="border-top:none;float:right;">
                        <button v-if="!loadingAgentData" class="ob-button mt-2" style="cursor:pointer;align-items:center" @click="verifyCode">Proceed</button>
                        <div  v-if="loadingAgentData" class="rotate-btn-wrap mt-2" style = "align-items:center">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
                <div v-if="resendbanned">
                    <!-- dont allow user to resend code -->
                </div>
                <div v-else>
                    <div v-if="resendCode" class="sa-frm-row mb-0 mt-2">
                        <div class="region-info-text" >
                            <span class="lbl"><a id="termsOfService" class="cursor-pointer" @click.prevent="resendTimer();" style="color: rgb(25, 156, 198);text-decoration: underline;">Click</a> here to resend the code </span>
                        </div>
                    </div>
                    <div v-else class="sa-frm-row mb-0 mt-2">
                        <div class="region-info-text" >
                            <span class="lbl"><a style="color: rgb(25, 156, 198);">Resend </a>code in {{resendtimertext}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>

       
        <PrivacyPolicy v-if="showPrivacyPopup" @closePopup="closePopup"/>
        <WorbixTermsPopup v-if="showTermsPopup" @closePopup="closePopup"/>
        <AdminEmail v-if="mailPopup" :agent="mailData" @closePopup="closePopup"/>
        <div id="panelBackdrop" v-if="showPrivacyPopup || showTermsPopup || mailPopup"></div>
    </div>
</main>
</template>

<script>
// @ is an alias to /src
import AgentLogo from '@/components/agent-logo.vue'
import FooterLeft from '@/components/footer-left.vue'
import ExistingUser from '@/components/ExistingUser.vue'
import ConfirmBrokerage from '@/components/ConfirmBrokerage.vue'
import Multiselect from 'vue-multiselect'
import PrivacyPolicy from '@/components/PrivacyPolicy.vue'
import AdminEmail from '@/components/AdminEmail.vue'
import WorbixTermsPopup from '@/components/WorbixTermsPopup.vue'
import {appEnv, worbixServerUrl, invitationLink, demoNRDS, relevateUrl, fakeBrokerageEmail} from '@/properties'
import { mapActions } from "vuex";
export default {
    name: 'State',
    components: {
        AgentLogo,
        ConfirmBrokerage,
        FooterLeft,
		Multiselect,
        WorbixTermsPopup,
        ExistingUser,
        PrivacyPolicy,
        AdminEmail
    },
    data(){
        return{
            agentKey:"",
            phone:"",
            phoneList:[],
            allowMail:false,
            textContent:'10:00',
            resendtimer: null,
            resendtimertext: '59s',
            existingUser:false,
            showSelectTeamUI:false,
            termsOfService:false,
            errorText:'',
            agentInfo:null,
            intervalMethod:null,
            verificationCode:null,
            mailData:null,
            agentFullName : '',
            agentEmail :'',
            loadingAgentData:false,
            showTermsPopup:false,
            showPrivacyPopup:false,
            mailPopup:false,
            resendCode: true,
            resendbanned: false,
            currentView : 'AGENT_NRDS',
            testNumbers:[
                {'number':'813-048-2748', 'countryCode':'+91', type : 'test'},
                {'number':'989-101-4504', 'countryCode':'+91', type : 'test'},
                {'number':'981-088-7977', 'countryCode':'+91', type : 'test'},
                {'number':'813-090-1514', 'countryCode':'+91', type : 'test'},
                {'number':'880-091-4561', 'countryCode':'+91', type : 'test'},
                {'number':'612-756-6422', 'countryCode':'+1', type : 'test'}
            ],
            teamsList: []
        }
    },
	mounted(){    
        console.log('mounted called');
        // temp code to direct open otp screen
        // this.currentView = 'VERIFY_CODE'
        // this.phone = this.testNumbers[0]
        // this.agentKey = '502002600'
        console.log('beforeRouteEnter', this.currentView, this.agentKey);
        this.initialize();       
	},
    computed:{
        orgTitle (){
            return this.$store.state.orgTitle
        },
        updateEmail(){
            console.log({appEnv});
            let updateEmail = false;
            if (appEnv != 'prod') {
                updateEmail = true;
            }
            return  updateEmail
        }
    },
	methods:{
        ...mapActions({
            getAgentData: "getAgentData",
            checkIfAgentExists: "checkIfAgentExists",
            fetchTeamForOfficeId: "fetchTeamForOfficeId",
            _sendConfirmationCode: "sendConfirmationCode",
            _verifyConfirmationCode: "verifyConfirmationCode"
        }),
        initialize(){
            this.currentView = 'AGENT_NRDS';
            this.termsOfService = false;
            this.agentKey = '';
        },
        updatePhoneList(agent){
            let phoneFeilds = ['CellPhone', 'HomePhone', 'OfficePhone', 'PreferredPhone']
            let tempList = []
            Object.keys(agent).forEach((row)=>{
                if(phoneFeilds.includes(row) && !tempList.includes(agent[row])){
                    tempList.push(agent[row]);
                    this.phoneList.push({'number':agent[row], 'countryCode':'+1', type : 'actual'})
                }
            })    
           if(appEnv != 'prod'){
                this.phoneList = this.phoneList.concat(this.testNumbers)
           }
        },
        startTimer(duration) {
            let vm = this;
            var timer = duration, minutes, seconds;
            this.intervalMethod = setInterval( () => {
                minutes = parseInt(timer / 60, 10);
                seconds = parseInt(timer % 60, 10);

                minutes = minutes < 10 ? "0" + minutes : minutes;
                seconds = seconds < 10 ? "0" + seconds : seconds;

                this.textContent = minutes + ":" + seconds;
                // console.log('textContent', this.textContent);
                if (--timer < 0) {
                    //timer = duration;
                    clearInterval(this.intervalMethod);
                }
            }, 1000);
        },
        resendTimer(){
            let seconds;
            seconds = 59;
            
            this.resendtimertext = seconds + 's'
            this.resendCode = false;
            this.sendCode();
            this.loadingAgentData = false;                         //dont load proceed btn on resend click

            this.resendtimer = setInterval(() => {
                this.resendtimertext = seconds + 's'
                if (--seconds < 0) {
                    clearInterval(this.resendtimer);
                    this.resendCode = true;
                }
            },1000)
        },
        getFormattedPhoneNUmber(phone){
            return phone.countryCode + phone.number.replace(/-/g, '');
        },
        async sendCode(restartCounter){
            let params = {}
            console.log('phone', this.phone);
            if(!this.phone){
                this.errorText = 'enterNumber'
                return
            }
            if(appEnv != 'prod' && this.phone.type != 'test'){
                this.errorText = 'wrongNumber'
                return
            }
            params['phoneNumber'] = this.getFormattedPhoneNUmber(this.phone);
            this.loadingAgentData = true;
            let res = await this._sendConfirmationCode(params);
            this.loadingAgentData = false;
            if(res.error){
                this.errorText = 'sendingFailed'
                if(res.error == 'Max send attempts reached, Please try to complete the verification process or wait for 10 min to code expire.'){
                    this.errorText = 'sendLimitExceeded'
                    this.resendbanned = true;
                }
                return;
            }
            this.errorText = '';
            this.currentView = 'VERIFY_CODE';
            clearInterval(this.intervalMethod)
            var minutes = 60 * 10;
            this.startTimer(minutes);
            
        },
        async verifyCode(){
            if (!this.verificationCode) {
                this.errorText = 'enterCode'
                return;
            }
            let params = {}
            params['phoneNumber'] = this.getFormattedPhoneNUmber(this.phone);
            params['code'] = this.verificationCode;
            this.loadingAgentData = true;
            let confirmResponse = await this._verifyConfirmationCode(params);
            console.log({confirmResponse});

            if(confirmResponse.valid){
                this.moveToSignup()
            }else{
                this.errorText = 'wrongCode'
            }
            this.loadingAgentData = false;
        },
		async getAgentDetails(){
            if (!this.agentKey) {
                this.errorText = 'enterKey'
                return;
            }
            if (this.agentKey && (!this.validateNumber(this.agentKey) || this.agentKey.length != 9)) {
                this.errorText = 'wrongFormat'
                return;
            }
            if (!this.termsOfService) {
                this.errorText = 'checkTerms'
                return;
            }

			let payload = {
				agentKey : this.agentKey,
                updateEmail : this.updateEmail,
                saveAgentToWorbix:false,
                invitationLink:invitationLink
			}

            this.loadingAgentData = true;
            let agentData = await this.getAgentData(payload);
            this.agentInfo = agentData;
            if (agentData && !Object.keys(agentData).length) {
                this.errorText = 'wrongInfo';
                this.loadingAgentData = false;
                return;
            }
            let officeId = agentData.brokerage.OfficeReference;
            payload['officeId'] = officeId;
			let agentWorbixStatus = await this.checkIfAgentExists(payload);
            if(agentWorbixStatus.invitationStatus == 'ACCEPTED') {
                this.loadingAgentData = false;
                this.existingUser = true;
                this.agentFullName = this.agentInfo.agent.FirstName;
                return;
            }

            this.updatePhoneList(this.agentInfo.agent);
            this.currentView = 'SEND_CODE';
            this.loadingAgentData = false;
		},
        moveToSignup(){
            // await this.createAgent(true);
            // this.initialize(); 
            // window.location.href = `${relevateUrl}onboarding/${this.agentKey}`;
            window.location.replace(`${relevateUrl}onboarding/${this.agentKey}`);
            
        },
        async createAgent (saveAgentToWorbix){
            this.loadingAgentData = true;
            let payload = {
                agentKey : this.agentKey,
                updateEmail : this.updateEmail,
                saveAgentToWorbix: saveAgentToWorbix,
                invitationLink: invitationLink
            }
            let res = await this.getAgentData(payload);
            if (res && !Object.keys(res).length) {
                this.errorText = 'wrongInfo';
            }else {
                this.agentInfo = res;
                this.agentEmail = this.agentInfo.agent.EMail;
                this.agentFullName = this.agentInfo.agent.FirstName;
            }
            // this.loadingAgentData = false;
        },
        resetError(evt){
            let code = (evt.keyCode ? evt.keyCode : evt.which);
            if (code != 13) {
                this.errorText = '';
                return
            }
            this.getAgentDetails()
        },
        resetAndVerify(evt){
            let code = (evt.keyCode ? evt.keyCode : evt.which);
            if (code != 13) {
                this.errorText = '';
                return
            }
            this.verifyCode();
        },
        validateNumber(number){
            const re = /^[0-9]+$/;
            return re.test(number);
        },
        closePopup(){
            this.showPrivacyPopup = false;
            this.showTermsPopup = false;
            this.mailPopup = false;
        },
        async sendAdminMail(){
            let payload = {};

            let fakeBrokerageInvite = await this.$store.dispatch("sentMailToAdmin", payload);
        },
	}
}
</script>

<style lang="scss">
.error-wrapper{
    text-align: left;
    color: #ffffff;
    background-color: #db082b;
    border-color: #a00620;
    padding: 15px;
    border-radius: 4px;
    width: 500px;
    font-size: 25px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding-top: 25px;
}

.error-wrapper .fa{
    position: absolute;
    right: 8px;
    top: 5px;
    cursor: pointer;
}

.multiselect.form-control.multi-dropdown {
	padding: 0;
	height: auto;
}
.multi-select .multiselect.form-control.multi-dropdown {
    border: 1 #e1e1e1 solid;
	height:98px
}

.multi-select .multiselect__tags{
	border:0px;
	font-size:14px;
	font-family:inherit;
	height:98px
}

.multi-select .multiselect__select{
	height:98px
}

.multi-select .multiselect__single{
	font-size:45px;
	color:#666666;
	font-weight:300;
	display: inline-flex;
	align-items: center;
	height:100%;
	overflow:hidden;
	white-space: nowrap;
}

.multi-select .multiselect__input{
	font-size:45px;
	color:#666666;
	font-weight:300;
	height:100%
}

.multi-select .multiselect__element{
	color:#666666;
}

.multi-select .multiselect__option{
    font-size: 1.25rem;
}

.phone-list-wrap{
    width: 350px;
    margin: 0px auto;
    height: auto;
    .phone-item{
        padding: 0;
        height: 25px;
        float:left;
        text-align: center;
        width: 100%;
        line-height: 1 !important;
        input[type=radio]{
            height: 14px;
            margin-right: 8px;
            position: relative;
            cursor: pointer;
        }
        span{
            font-size: 16px;
            &.test{
                color: green;
            }
        }
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
    }
}

.select-agent-type input[type=radio]{
    height: 14px;
    margin-right: 8px;
    top: 2px;
    position: relative;
    cursor: pointer;
}
.select-agent-type span{
    font-size: 16px;
}
.select-agent-type{
    text-align: left;
    padding: 0;
    height: 25px;
    float:left;
}

</style>
